module.exports = __webpack_public_path__ + "img/2025-10-15a_1.76f62f43.jpg";